<template>
    <LayoutSub className="business_unit">
        <SubSection classList="pb-0">
            <h1>
                전사적 경영전략을 수립하고 <br class="mo-only"/>전사적 업무 전반을 관리, 지원하는 <br />
                한국정보통신 <strong class="c-red">경영지원본부</strong>
            </h1>
            <p>
                한국정보통신 경영지원본부는 재경팀/인사팀/경영기획팀으로 이루어져 있습니다. <br />
                각각의 팀은 회사의 경영전략을 수립하고, 전사 업무 전반에 관한 기획 및 조정, 조직/예산 관리, 인사제도, 복리후생, 결산/회계, 법률자문,
                IR 등의 업무를 유기적으로 수행하고있습니다.<br />
                구성원의 역량강화 및 핵심인재 육성을 위한 전사 교육 프로그램을 운영하고 있으며, 상시 리스크 관리를 위한 일련의 활동(내부통제/내부회계/
                RM 등)을 수행합니다.<br />
                마케팅, IT, 연구소 등 현업부서간 협업 및 시너지 증대를 위한 총괄/지원 업무를 수행합니다.
            </p>
            <img src="@/assets/management_support_image01.png" alt="" />
        </SubSection>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
    },
};
</script>